import { gql } from "@apollo/client";

export const GET_STOCK = gql`
 query Stock($where: StockWhereInputOne!) {
    stock(where: $where) {
      id
      price
      originPrice
      amount
      amountAll
      amountSale
      image
      containImages
      cfMessage
      name
      unit
      sort
      isDeleted
      isUsingSalePage
      isRecommended
      currency
      reduction
      reductionType
      categoryName
      category {
        id
        name
      }
      properties {
        title
        detail
      }
      descriptions {
        title
        image
      }
      shop {
        id
        name
        phone
        website
        facebookUrl
        point
        paymentType
        startDate
        endDate
        isBlocked
        isDeleted
      }
      product {
        id
        title
        amount
        priceLak
        priceThb
        priceUsd
        description
        unit
        image
      }
      optionValues {
        id
        name
        value
        isDeleted
      }
      createdAt
      updatedAt
      note
    }
}
`;

export const GET_STOCKS_ORDER_REPORT = gql`
  query ReportStockOrder($where: StockReportWhereInput, $skip: Int, $limit: Int) {
    reportStockOrder(where: $where, skip: $skip, limit: $limit) {
      status
      dataMany {
        id
        name
        categoryName
        amount
        price
        originPrice
        currency
      }
      total
      tag
      msg
      err
    }
  }
`;

export const GET_STOCKS = gql`
query Data($where: StockWhereInput, $limit: Int, $skip: Int, $orderBy: OrderByInput) {
  stocks(where: $where, limit: $limit, skip: $skip, orderBy: $orderBy) {
    data {
      id
      price
      amount
      name
      image
      currency
      originPrice
      coverImages
      containImages
      descriptions {
        title
        image
      }
      properties {
        title
        detail
      }
      unit
      cfMessage
      isDeleted
      
      product {
        id
        title
        amount
        image
        price
      }
      createdAt
      sort
      note
      category {
        id
        name
      }
      categoryName
      isUsing
      isUsingSalePage
      favorite
      reduction
      updatedAt
      optionValues {
        id
        name
        value
        isDeleted
      }
      
    }
    total
  }
}
`;

export const GET_STOCKS_V2 = gql`
  query StocksV2($where: StockWhereInput, $skip: Int, $limit: Int, $orderBy: OrderByInput) {
    stocksV2(where: $where, skip: $skip, limit: $limit, orderBy: $orderBy) {
      total
      amountStocks
      lowStockCount
      outStockCount
      data {
        id
        price
        originPrice
        currency
        amount
        amountAll
        amountSale
        image
        coverImages
        containImages
        descriptions {
          title
          image
        }
        name
        unit
        cfMessage
        isDeleted
        isUsing
        createdAt
        updatedAt
        note
        sort
        isUsingSalePage
        favorite
        reduction
        reductionType
        platforms
        category {
          id
          name
        }
        categoryName
        optionValues {
          id
          name
          value
          isDeleted
          createdAt
          updatedAt
          note
        }
      }
    }
  }
`;
export const GET_STOCKS_IN_LIVE = gql`
  query StocksInLive($where: StockWhereInput, $skip: Int, $limit: Int, $orderBy: OrderByInput) {
    stocksInLive(where: $where, skip: $skip, limit: $limit, orderBy: $orderBy) {
      total
      amountStocks
      data {
        id
        price
        originPrice
        currency
        amount
        amountAll
        amountSale
        image
        coverImages
        containImages
        descriptions {
          title
          image
        }
        name
        unit
        cfMessage
        isDeleted
        isUsing
        createdAt
        updatedAt
        note
        sort
        isUsingSalePage
        favorite
        reduction
        categoryName
        optionValues {
          id
          name
          value
          isDeleted
          createdAt
          updatedAt
          note
        }
      }
    }
  }
`;

export const REPORT_STOCKS = gql`
query StockSalesReport($shopId: ID) {
  stockSalesReport(shopId: $shopId) {
    productName
    total
    sold
    remaining
  }
}
`